module.exports = __webpack_public_path__ + "Roboto-Light.3c37aa69cd77e6a53a06.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/yoann/Perso/Pedicure-Podologue/~/materialize-css/dist/fonts/roboto/Roboto-Light.woff2
// module id = ../../../../materialize-css/dist/fonts/roboto/Roboto-Light.woff2
// module chunks = 2